var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","position-x":_vm.tooltipX,"position-y":_vm.tooltipY,"color":"black"},model:{value:(_vm.showCopied),callback:function ($$v) {_vm.showCopied=$$v},expression:"showCopied"}},[_c('span',[_vm._v("Copied!")])])}
var staticRenderFns = []

export { render, staticRenderFns }